import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import type { Router } from 'vue-router';

let appInsights: ApplicationInsights | null = null;

/**
 * Application Insights for errors and page views.
 * Cookies stay disabled until the user grants analytics consent.
 */
export function initTelemetry(connectionString: string | undefined, analyticsConsent: boolean): void {
  if (!connectionString || appInsights) return;
  appInsights = new ApplicationInsights({
    config: {
      connectionString,
      disableCookiesUsage: !analyticsConsent,
      disableAjaxTracking: true,
      disableFetchTracking: true,
    },
  });
  appInsights.loadAppInsights();
}

export function setTelemetryConsent(granted: boolean): void {
  appInsights?.getCookieMgr().setEnabled(granted);
}

export function trackRouter(router: Router): void {
  router.afterEach((to) => {
    appInsights?.trackPageView({ name: String(to.name ?? to.path), uri: to.path });
  });
}

export function trackException(error: unknown, properties?: Record<string, unknown>): void {
  if (!appInsights) return;
  const exception = error instanceof Error ? error : new Error(String(error));
  appInsights.trackException({ exception }, properties);
}
